import { Button } from "@mui/material";
import { validators } from "../../validators/validators";
import { useTranslation } from "react-i18next";
import { isStandardOrB2BOrC2CPackage } from "../../helpers/packageTypesHelper/packageTypesHelper";

const Places = ({ state, setState }) => {
    const {t} = useTranslation()
    const volumeWeights = state.places.map((place) => {
        if (place.weight === "" || place.width === "" || place.height === "" || place.length === "") 
            return 0;
        return (place.width * place.height * place.length) / 5000;
    });
    
    const setWeight = (index, value) => {
        //if value is empty string, then set weight to empty string
        if (value === "")
            setState((prev) => ({
                ...prev,
                places: prev.places.map((place, i) =>
                    i === index ? { ...place, weight: "" } : place
                ),
            }));

        let err = validators.ValidateNumber(value);
        if (err !== null) return;

        setState((prev) => ({
            ...prev,
            places: prev.places.map((place, i) =>
                i === index ? { ...place, weight: value } : place
            ),
        }));
    };
    const getWidth = (index) => {
        return state.places[index].width;
    }
    const getLength = (index) => {
        return state.places[index].length;
    }
    const getHeight = (index) => {
        return state.places[index].height;
    }

    const setWidth = (index, value) => {
        //if value is empty string, then set weight to empty string
        if (value === "")
            setState((prev) => ({
                ...prev,
                places: prev.places.map((place, i) =>
                    i === index ? { ...place, width: "" } : place
                ),
            }));

        let err = validators.ValidateNumber(value);
        if (err !== null) return;

        setState((prev) => ({
            ...prev,
            places: prev.places.map((place, i) =>
                i === index ? { ...place, width: value } : place
            ),
        }));
    };

    const setLength = (index, value) => {
        //if value is empty string, then set weight to empty string
        if (value === "")
            setState((prev) => ({
                ...prev,
                places: prev.places.map((place, i) =>
                    i === index ? { ...place, length: "" } : place
                ),
            }));

        let err = validators.ValidateNumber(value);
        if (err !== null) return;

        setState((prev) => ({
            ...prev,
            places: prev.places.map((place, i) =>
                i === index ? { ...place, length: value } : place
            ),
        }));
    };

    const setHeight = (index, value) => {
        //if value is empty string, then set weight to empty string
        if (value === "")
            setState((prev) => ({
                ...prev,
                places: prev.places.map((place, i) =>
                    i === index ? { ...place, height: "" } : place
                ),
            }));

        let err = validators.ValidateNumber(value);
        if (err !== null) return;

        setState((prev) => ({
            ...prev,
            places: prev.places.map((place, i) =>
                i === index ? { ...place, height: value } : place
            ),
        }));
    };

    const handleDeleteButtonClick = (index) => {
        setState((prev) => ({
            ...prev,
            places: prev.places.filter((_, i) => i !== index),
        }));
    };

    return (
        <div className="flex flex-col gap-4">
            {state.places.map((place, index) => (
                //if index is 0, then don't add margin bottom, because it doesn't have delete button
                <div key={index} className={index !== 0 ? "mb-4" : ""}>
                    <span className="text-xl text-emerald-600">
                        {t("calculator.places.place")} {index + 1}
                    </span>
                    <div>
                        <input
                            className="w-full p-2 pt-0 text-3xs xs:text-sm md:text-md   border-b border-b-gray-400 hover:border-b-gray-500 text-left focus:outline-none"
                            type="text"
                            placeholder={t("calculator.places.weight")}
                            value={place.weight}
                            //change weight and validate, if it is not a number, then return, but if is empty string, then set weight to empty string
                            onChange={(e) => setWeight(index, e.target.value)}
                        />
                    </div>
                    {isStandardOrB2BOrC2CPackage(state["package-type"]) && 
                    <div className="flex gap-2 xs:gap-4 md:gap-10">
                        <div className="w-full flex flex-col">
                            <input
                                className="p-2  w-full text-3xs xs:text-sm md:text-md  border-b border-b-gray-400 hover:border-b-gray-500 text-left focus:outline-none"
                                type="text"
                                placeholder={t("calculator.places.width")}
                                value={place.width}
                                onChange={(e) => setWidth(index, e.target.value)}
                            />
                            {   !getWidth(index) &&
                                <span className="text-3xs text-red-500">*</span>
                            }
                        </div>
                        <div className="w-full flex flex-col">
                            <input
                                className="p-2 w-full text-3xs xs:text-sm md:text-md  border-b border-b-gray-400 hover:border-b-gray-500 text-left focus:outline-none"
                                type="text"
                                placeholder={t("calculator.places.height")}
                                value={place.height}
                                onChange={(e) => setHeight(index, e.target.value)}
                            />
                            {   !getHeight(index) &&
                                <span className="text-3xs  text-red-500">*</span>
                            }
                        </div>
                        <div className="w-full flex flex-col">
                            <input
                                className="p-2  w-full  text-3xs xs:text-sm md:text-md border-b border-b-gray-400 hover:border-b-gray-500 text-left focus:outline-none"
                                type="text"
                                placeholder={t("calculator.places.length")}
                                value={place.length}
                                onChange={(e) => setLength(index, e.target.value)}
                            />
                            {   !getLength(index) &&
                                <span className="text-3xs  text-red-500">*</span>
                            }
                        </div>
                    </div>}

                    <div className="text-left text-xs mt-2 ml-4">
                        {   volumeWeights[index] !== undefined && 
                            volumeWeights[index] > place.weight && 
                            (<span className=" text-orange-600">
                                *{t("calculator.places.volume_weight")}: {volumeWeights[index].toFixed(2)} kg
                            </span>)
                        }
                    </div>

                    {index !== 0 && (
                        <div className="mt-4">
                            <Button
                                variant="contained"
                                sx={{
                                    color: "white",
                                    bgcolor: "#dc2626",
                                    fontSize: "0.7rem",
                                    ":hover": {
                                        bgcolor: "#b91c1c",
                                    },
                                }}
                                onClick={() => handleDeleteButtonClick(index)}
                            >
                                {t("calculator.places.delete_place_button")}
                            </Button>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Places;
